import React from 'react';
import styles from './index.css';
import { shadow } from '@src/constants/index';

const content = ({ goResult, item, length, index, id }) => {
    return (
        <div className={styles.contentItem}>
            <div
                className={styles.contenttitle}
                onClick={() => {
                    goResult(id);
                }}>
                {item?.title}
                {item?.isHot && <div className={styles.hot}>HOT</div>}
            </div>

            {length % 2 === 0 && length - 1 !== index && length - 2 !== index && <img src={shadow} className={styles.itemShadow} />}
            {length % 2 === 1 && length - 1 !== index && (
                <img src="https://x0.ifengimg.com/ucms/2025_11/189E36C987F2272562AB6F199F7C6EA5F28B9D47_size1_w294_h10.png   " className={styles.itemShadow} />
            )}
        </div>
    );
};

export default content;
